import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import Paper from "@material-ui/core/Paper";
import withStyles from "components/with-styles";
import styles from "./styles/page-section.css.js";

const PageSection = ({ className, children, classes, hideBackground, spaced, buttons, subsection = false }) => {
  return hideBackground ? (
    <div className={cn(className, classes.section, { [classes.spaced]: spaced })}>{children}</div>
  ) : (
    <Paper
      elevation={2}
      className={cn(className, classes.section, classes.section__background, {
        [classes.spaced]: spaced,
        [classes.section__subsection]: subsection,
      })}
    >
      {children}
    </Paper>
  );
};

PageSection.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Pone estilos de subsección
   */
  subsection: PropTypes.bool,
  /**
   * Añade espacio de separación superior
   */
  spaced: PropTypes.bool,
  /**
   * Oculta el background de la sección
   */
  hideBackground: PropTypes.bool,
  /**
   * Elemento con el contenido de la botonera
   */
  buttons: PropTypes.element,
};

export default withStyles(styles)(PageSection);
